import React from 'react';
import { FormattedMessage } from 'react-intl';
import Swiper, { Autoplay } from 'swiper';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';
interface Prop {
    images: Array<string>;
}
interface State {}

Swiper.use([Autoplay]);

@injectIntl()
export default class Slide extends Base<Prop, State> {
    private swiper: any = null;

    constructor(prop: Prop) {
        super(prop);
    }

    componentDidMount() {
        this.swiper = new Swiper('.swiper-container', {
            observer: true,
            observeSlideChildren: true,
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
            autoplay: {
                delay: 2000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
            },
        });
    }

    componentDidUpdate(newProps: any, newState: any) {
        if (newProps.images !== this.props.images) {
            this.swiper.update(true);
        }
    }

    render() {
        const { images } = this.props;
        return (
            <>
                <div className="boxs white_bg swiper-container">
                    <div className="swiper-wrapper">
                        {images?.map((src, index) => {
                            return (
                                <div className="swiper-slide" key={src + index}>
                                    <img
                                        className="single-img"
                                        src={src}
                                        alt=""
                                        onLoad={() => {
                                            this.swiper?.update(true);
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    }
}
